import { Component, OnDestroy, OnInit } from '@angular/core';
import { TitlecasePipe } from "../../../../custom-pipe/titlecase/titlecase.pipe";
import { PhilReportService } from '../../../../services/raintree/Transmission/phil-report';
import { AppConfigService } from '../../../../services/config/app-config.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import moment from 'moment-timezone';
import { Dp1OrptFilterComponent } from './dp-1-orpt-filter/dp-1-orpt-filter.component';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dp-1-o-report',
  standalone: true,
  imports: [TitlecasePipe, FormsModule, DatePipe],
  templateUrl: './dp-1-o-report.component.html',
  styleUrl: './dp-1-o-report.component.scss'
})
export class Dp1OReportComponent implements OnInit, OnDestroy {
  keydata: any = { startDate: '', endDate: '', uiCountry: '', type: '' };
  apiValue: any[] = [];
  reportType: string = 'date'
  userName: any;
  selectedReport?: string = 'date';
  totalValue: any;
  assignedValue: any;
  unasingedValue: any;
  userValue: any;
  userSearch: any[] = [];
  userTableHeads = [
    { key: 'fullName', label: 'FULL NAME' },
    { key: 'email', label: 'EMAIL' },
    { key: 'effort', label: 'EFFORT' }
  ];

  dateWiseTbleHeads = [
    { key: 'dt', label: 'DATE' },
    { key: 'today_assigned', label: 'TODAY ASSIGNED' },
    { key: 'today_unassigned', label: 'TODAY UNASSIGNED' }
  ];
  TableHeadCount: number = this.userTableHeads.length


  constructor(
    private serApi: PhilReportService,
    private comSer: AppConfigService,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.userName = localStorage.getItem('fullName')?.split(' ');
    const allPermissionV3: any = this.comSer.getAllPermissionsV3();
    this.keydata.uiCountry = Object.keys(allPermissionV3['Statistics']['DP 1.0 Report']['default']['PERMISSION'])[0]; //setting the country dynamically
    this.keydata.startDate = moment().tz('Asia/Kolkata').startOf('day').format('YYYY-MM-DD');
    this.keydata.type = this.selectedReport;
    // console.log(this.keydata.startDate, 'START DATE');
    this.getGlobalStatisticsData(this.keydata);
  }

  getGlobalStatisticsData(params: any) {
    this.serApi.fetch1DpGlobal10StatisticsData(params).subscribe({
      next: (result: any) => {
        this.apiValue = [];
        if (!result.error && result.data.length > 0) {
          this.apiValue = result.data;
          this.userSearch = this.apiValue;
          if (params.type === 'date') {
            this.totalValue = result.data[0].total;
            localStorage.setItem('totEffortInt', this.totalValue);
            this.assignedValue = result.data[0].total_assigned;
            localStorage.setItem('assignEffortInt', this.assignedValue);
            this.unasingedValue = result.data[0].total_unassigned;
            localStorage.setItem('unassignEffortInt', this.unasingedValue);
          }
          if (params.type === 'user') {
            this.totalValue = localStorage.getItem('totEffortInt') || 0;
            this.assignedValue = localStorage.getItem('assignEffortInt') || 0;
            this.unasingedValue = localStorage.getItem('unassignEffortInt') || 0;
          }
          console.log('ALL APIS DATA', result.data)
        }
      },
      error: (error: any) => {
        this.toastr.clear();
        this.toastr.error(error);
      }
    })
  }

  onClickDateWise(type: string) {
    this.selectedReport = type
    this.keydata.type = this.selectedReport
    this.reportType = 'date'
    this.getGlobalStatisticsData(this.keydata)
  }
  onClickUserWise(type: string) {
    this.selectedReport = type
    this.keydata.type = this.selectedReport
    this.reportType = 'user'
    this.getGlobalStatisticsData(this.keydata)
  }


  onClickDialog() {
    const dialogRef = this.dialog.open(Dp1OrptFilterComponent, { data: this.keydata })
    dialogRef.afterClosed().subscribe((res: any) => {
      this.keydata.startDate = res.startDate;
      this.keydata.endDate = res.endDate
      this.getGlobalStatisticsData(this.keydata)
      console.log('dialogData', res);
    })
  }

  onSearch(value: string) {
    const userValue = value.toLowerCase().trim();
    this.apiValue = this.userSearch.filter(item =>
      item.dt.includes(userValue) ||
      item.today_assigned.includes(userValue) ||
      item.today_unassigned.includes(userValue)
    )
    if (userValue === '') {
      this.apiValue = this.apiValue;
    }

  }

  ngOnDestroy(): void {
    localStorage.removeItem("totEffortInt");
    localStorage.removeItem("assignEffortInt");
    localStorage.removeItem("unassignEffortInt");
  }

}
